import axios from 'axios';
import { sendNotfication, API } from '../Helper';

export const launchGame = async (gameUid, userId, currencyCode,amount) => {
  
try {

  const coins = localStorage.getItem('coin') || 'USDT';
  if (coins !== 'USDT'&&coins !== 'INR') {
      sendNotfication("Please Swap Into USDT To Play", "error");
    this.setState({ loading: false });
    return;
  }

    const payload = {
      game_uid: gameUid,
      user_id: userId,
      credit_amount: amount,
      currency_code: currencyCode,
      language:'en',
    };
   
     // Make the API call to launch the game
          const response = await fetch(`https://bkk07.com/jsGames/game/launch`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
    
          // Check if the response is successful
          if (!response.ok) {
            // throw new Error("Network response was not ok");
            sendNotfication("Error Launching Game","error")
          }    
    
          // Parse the response
          const result = await response.json();
    
          // Check if game launch was successful
          if (result.success && result.payload && result.payload.game_launch_url) {
          
            return result.payload.game_launch_url
          }

  } catch (error) {
    console.error('Error launching game:', error);

    return null;
  }
};
 